(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/overview-hero/assets/javascripts/hooks/use-user-state.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/overview-hero/assets/javascripts/hooks/use-user-state.js');

'use strict';

const {
  OverviewUserState
} = svs.components.marketplaceCompetition.overviewHero.constants;
const {
  usePlayerCompetitions,
  usePlayerCompetitionDraws
} = svs.components.marketplaceCompetition.services.hooks;
const {
  REG_CLOSED_DRAW_FINALIZED
} = svs.components.marketplaceCompetition.competitionHandler.common.constants.competitionStates;

const useUserState = _ref => {
  let {
    competition,
    overrides = {}
  } = _ref;
  let {
    currentDrawNumber
  } = (competition === null || competition === void 0 ? void 0 : competition.details) || {};
  const competitionStatus = competition === null || competition === void 0 ? void 0 : competition.status;
  if (competitionStatus && competitionStatus === REG_CLOSED_DRAW_FINALIZED) {
    currentDrawNumber = competition.details.drawNumberList[competition.details.drawNumberList.findIndex(drawNumber => drawNumber === currentDrawNumber) - 1];
  }
  const playerCompetitions = usePlayerCompetitions();
  const playerDraws = usePlayerCompetitionDraws(competition === null || competition === void 0 ? void 0 : competition.id);
  if (!(competition !== null && competition !== void 0 && competition.id)) {
    return;
  }
  if (overrides.userState) {
    return overrides.userState;
  }
  const isUserLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  if (!isUserLoggedIn) {
    return OverviewUserState.IS_NOT_LOGGED_IN;
  }
  const isUserRegisteredInCompetition = competition.id && (playerCompetitions === null || playerCompetitions === void 0 ? void 0 : playerCompetitions[competition.id]);
  if (!isUserRegisteredInCompetition) {
    return OverviewUserState.IS_NOT_REGISTERED;
  }
  const hasUserSettledBetInCurrentGame = competition.id && currentDrawNumber && Array.isArray(playerDraws) && playerDraws.includes(currentDrawNumber);
  if (!hasUserSettledBetInCurrentGame) {
    return OverviewUserState.HAS_NO_CURRENT_BET;
  }
  return OverviewUserState.HAS_CURRENT_BET;
};
setGlobal('svs.components.marketplaceCompetition.overviewHero.hooks.useUserState', useUserState);

 })(window);